import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setStep, goToPage, GetUserDetails, GetDetailsDeviceUpgrade } from '../IdfSaleBlock/IdfSaleSlice';
import OrderSummaryPhoneUpgrade from '../IdfSaleBlock/SaleSteps/OrderSummaryPhoneUpgrade';
import GeneralError from '../IdfSaleBlock/Constans/GeneralError';
import Header from '../IdfSaleBlock/Constans/Header';
import Config from 'app/Config';
import EpiContext from "@episerver/spa-core/Spa";
import ErrorPage from '../IdfSaleBlock/PopUps/ErrorPage';

const IdfUpgradeDeviceMain = (props) => {
    const [showOrderSummary, setShowOrderSummary] = useState(false);
    const [errorPage, setErrorPage] = useState(false);
    const [orderData, setOrderData] = useState({});

    useEffect(() => {
        async function fetchData() {
            await props.GetDetailsDeviceUpgrade();
        }
        if (props.auth.loginData?.isFullAuthenticated) {
            fetchData();
        } else {
            EpiContext.navigateTo(Config.idfLoginUrl)
        }
    }, [props.auth?.loginData?.isFullAuthenticated]);

    useEffect(() => {
        if (props.idfStore.deviceUpgradeProcessing) {
            if (props.idfStore.canUpgradePhone) {
                props.context.navigateTo(props.iContent.joinLink.value);
            } else {
                if (props.idfStore.userDetails?.transaction_status_id == 'TransactionSAPOrderSucceeded') {
                    const data = {
                        processType: 'DEVICE',
                        selectedPhone: {
                            totalPrice: props.idfStore.orderDetails.orderModel.modelPrice,
                            selectedPayment: props.idfStore.orderDetails.numPayments,
                            insuranceOption: props.idfStore.orderDetails.orderModel.isInterestedInWarranty ? 'ADD_INSURANCE' : 'NO_INSURANCE',
                            groupName: props.idfStore.orderDetails.orderModel.modelName,
                        },
                        isLeasing: props.idfStore.userDetails.isLeasingPay === '1',
                        selectedEmail: props.idfStore.orderDetails.email,
                        warrantyPrice: props.idfStore.orderDetails.warrentyPrice,
                        deliveryMode: props.idfStore.orderDetails.deliveryTypeId == 'ServiceCenter' ? 'PICKUP' : 'DELIVERY',
                        deliverySelectedAddress: {
                            streetName: props.idfStore.orderDetails?.deliveryAddress?.deliveryStreetName,
                            home: props.idfStore.orderDetails?.deliveryAddress?.deliveryHouseNo,
                            entry: props.idfStore.orderDetails?.deliveryAddress?.deliveryHouseEntrance,
                            apartment: props.idfStore.orderDetails?.deliveryAddress?.deliveryAddressAptNo,
                            cityName: props.idfStore.orderDetails?.deliveryAddress?.deliveryCityName,
                        },
                        selectedDeliverySlot: {
                            deliveryStartTime: props.idfStore.orderDetails?.deliveryAddress?.deliveryStartTime,
                            deliveryEndTime: props.idfStore.orderDetails?.deliveryAddress?.deliveryEndTime,
                            hebrewDayName: props.idfStore.orderDetails?.deliveryAddress?.hebrewDayName,
                        },
                        deliverySelectedFirstName: props.idfStore.orderDetails?.deliveryAddress?.deliveryReceiverName,
                        deliverySelectedLastName: '',
                        deliverySelectedPhoneNumber: props.idfStore.orderDetails?.deliveryAddress?.deliveryReceiverPhone,
                        deliveryComments: props.idfStore.orderDetails?.deliveryAddress?.deliveryNotes,
                        orderDetails: {
                            paymentTypeId: props.idfStore.orderDetails.creditCardTypeId,
                            creditLast4Digit: props.idfStore.orderDetails.creditLast4Digit,
                            creditCardMonth: props.idfStore.orderDetails.creditCardMonth,
                            creditCardYear: props.idfStore.orderDetails.creditCardYear,
                        },
                        lineType: '',
                        pickupServiceCenter: {
                            service_center_name: props.idfStore.orderDetails.pickUpDetails?.pickupDistributionCenterName,
                            service_center_location: props.idfStore.orderDetails.pickUpDetails?.pickupDistributionCenterAddress,
                            // activity_hours:  ????
                        },
                        userDetails: {
                            user_type_id: props.idfStore.userDetails.user_type_id,
                        },
                    };
                    setOrderData(data);
                    setShowOrderSummary(true);
                } else {
                    setErrorPage(true);
                }
            }
        }
    }, [props.idfStore.deviceUpgradeProcessing]);

    const backToIdfSelfCare = () => {
        props.context.navigateTo(props.iContent.idfSelfCareLink?.value);
    };

    return (
        <div className='idf-upgrade-phone'>
            <Header onClickBack={() => backToIdfSelfCare()} />
            {showOrderSummary && (
                <OrderSummaryPhoneUpgrade
                    idfStore={orderData}
                    isSubmitSuccess={true}
                    isExistedOrder={true}
                    IdfSelfCareLink={props.iContent.idfSelfCareLink?.value}
                />
            )}
            {errorPage && <ErrorPage />}
        </div>
    );
};

const mapStateToProps = (state) => ({
    idfStore: state.idfSale,
    auth: state.authentication,
});

const mapDispatchToProps = {
    setStep,
    goToPage,
    GetUserDetails,
    GetDetailsDeviceUpgrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfUpgradeDeviceMain);
